import { TRANSITION_MOUNT_TYPE } from 'enums'
import ProjectTransitionAsset from 'models/ProjectData/ProjectTransitionAsset'

export const getTransitionMountType = transition => {
  if (!(transition instanceof ProjectTransitionAsset)) {
    return null
  }
  if (transition.rightVideoAssetId && transition.leftVideoAssetId) {
    return TRANSITION_MOUNT_TYPE.BETWEEN
  }
  if (transition.rightVideoAssetId) {
    return TRANSITION_MOUNT_TYPE.IN
  }
  if (transition.leftVideoAssetId) {
    return TRANSITION_MOUNT_TYPE.OUT
  }

  return null
}
